export default __webpack_public_path__ + "static/media/mike.2cb2d948.png";